// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e26122c7","703":"9882699b","787":"504e18a0"}[chunkId] + ".chunk.js";
};